import { createWorkerAction } from '../lib';

export const openFullScreenOverlay = createWorkerAction(
  'OPEN_FULL_SCREEN_OVERLAY',
);
